import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, NavigationEnd, Router, RouterModule, } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { filter } from 'rxjs';

@Component({
	selector: 'app-admin-course-setup-navbar',
	standalone: true,
	imports: [CommonModule, RouterModule, MatIconModule],
	templateUrl: './admin-course-setup-navbar.component.html',
	styleUrl: './admin-course-setup-navbar.component.scss',
})
export class AdminCourseSetupNavbarComponent {

	classroomId: string = '';
	showSidebar = true;
	currentStep = 1;
	currentUnlockedStep = 1;

	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private _toastr: ToastrService
	) { }


	ngOnInit(): void {
		this.route.paramMap.subscribe((params) => {
			this.classroomId = params.get('classroomId') ?? '';
		});

		const hideRoutes = ['course-preview', 'some-other-route'];

		this.showSidebar = !hideRoutes.some((route) => this.router.url.includes(route));
		this.router.events.pipe(filter(
			(event): event is NavigationEnd => event instanceof NavigationEnd)).subscribe((event) => {
				const url = event.urlAfterRedirects;
				this.showSidebar = !hideRoutes.some(route => url.includes(route));
				if (url.includes('resources')) {
					this.currentStep = 5;
				} else if (url.includes('outcomes')) {
					this.currentStep = 4;
				} else if (url.includes('modules')) {
					this.currentStep = 3;
				} else if (url.includes('objectives')) {
					this.currentStep = 2;
				} else {
					this.currentStep = 1;
				}
				this.currentUnlockedStep = Math.max(this.currentUnlockedStep, this.currentStep);
			});
	}


	goBack() {
		this.router.navigate(['/admin-student-platform/admin-courses']);
	}

	navigateToStep(event: MouseEvent, step: number, route: string) {
		if (step > this.currentUnlockedStep) {
			event.preventDefault();
			this._toastr.warning('Please complete the previous step first.');
			return;
		}
		this.router.navigate([route], {
			relativeTo: this.route,
		});
	}
	
}